import React from 'react'
import PenaltyTypePill from '../../elements/PenaltyTypePill'
import StatusPill from '../../elements/StatusPill'

const DisciplinaryRecordDetails = ({record, close}) => {
  return (
    <div className='w-full'>
        <div className='w-full my-4'>
            <label className='block text-sm text-gray-500 mb-[5px]'>Description</label>
            <p className='text-sm text-gray-700'>{record.description}</p>
        </div>


        <h3 className='text-[15px] font-medium mt-[20px]'>Penalties</h3>
        <p className='text-sm text-gray-600 mb-4'>Details of the penalties for this disciplinary redord</p>

        <div className='w-full mt-4 mb-4'>
            <label className='block text-sm text-gray-500 mb-[5px]'>Penalty type</label>
            <PenaltyTypePill type={record.penalty.type} />
        </div>

        {record.penalty.description && record.penalty.description !== '' && <div className='w-full my-4'>
            <label className='block text-sm text-gray-500 mb-[5px]'>Penalty Description</label>
            <p className='text-sm text-gray-700'>{record.penalty.description}</p>
        </div>}

        <div className='w-full my-4'>
            <label className='block text-sm text-gray-500 mb-[5px]'>Penalty Duration</label>
            <p className='text-sm text-gray-700'>{record.penalty.duration.length} {record.penalty.duration.type}</p>
        </div>

        <div className='w-full my-4'>
            <label className='block text-sm text-gray-500 mb-[5px]'>Penalty status</label>
            <StatusPill status={record.penalty.status} />
        </div>
    </div>
  )
}

export default DisciplinaryRecordDetails